var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevroneRight({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8297 12.4249L11.5381 15.8238C11.3106 16.0587 10.9427 16.0587 10.7176 15.8238L10.1706 15.259C9.94312 15.0241 9.94312 14.6442 10.1706 14.4117L12.5038 12.0025L10.1706 9.59325C9.94312 9.35833 9.94312 8.97844 10.1706 8.74602L10.7152 8.17619C10.9427 7.94127 11.3106 7.94127 11.5357 8.17619L14.8273 11.5751C15.0572 11.8101 15.0572 12.1899 14.8297 12.4249Z"
  })));
}

export default SvgChevroneRight;